<div>
    <view-device-transmit-information
        [dateLabel]="dateLabel"
        [activatorClinicFlg]="activatorClinicFlg"
        [orderTransmitterMsg]="orderTransmitterMsg"
        [dataMiningFlg]="dataMiningFlg"
        [showPhysicianOpt]="showPhysicianOpt"
        [isNGQCategory]="isNGQCategory"
        [isICMCategory]="isICMCategory"
        [isLPCategory]="isLPCategory"
        [functionMode]="functionMode"
        [displayMode]="displayMode"
        [patRes]="patRes"
    ></view-device-transmit-information>
    <view-patient-details
        [functionMode]="functionMode"
        [displayMode]="displayMode"
        [patRes]="patRes"
        [userProfile]="userProfile"
    ></view-patient-details>
    <view-address-contact-information
        [countryCd]="countryCd"
        [isNGQCategory]="isNGQCategory"
        [isICMCategory]="isICMCategory"
        (handleEmergencyCont)="handleEmergencyCont($event)"
        [toggleEmergencyCont]="toggleEmergencyCont"
        [showPhysicianOpt]="showPhysicianOpt"
        [functionMode]="functionMode"
        [displayMode]="displayMode"
        [patRes]="patRes"
    ></view-address-contact-information>
    <div *ngIf="!activatorClinicFlg">
        <view-direct-call-messaging
            *ngIf="patResSet"
            [functionMode]="functionMode"
            [displayMode]="displayMode"
            [patRes]="patRes"
            [userProfile]="userProfile"
        ></view-direct-call-messaging>
    </div>
</div>
